import { Link } from "react-router-dom";
import { Wallet as WalletIcon, ArrowDown, ArrowUp, ShoppingBag } from "lucide-react";

const TYPE_META = {
  topup:         { label: "شحن من الإدارة",  Icon: ArrowDown, color: "text-green-600", bg: "bg-green-50" },
  card_redeem:   { label: "شحن بكرت",         Icon: ArrowDown, color: "text-green-600", bg: "bg-green-50" },
  deduct:        { label: "خصم إداري",       Icon: ArrowUp,   color: "text-red-600",   bg: "bg-red-50" },
  order_payment: { label: "دفع طلب",         Icon: ShoppingBag, color: "text-primary-brand", bg: "bg-blue-50" },
  order_refund:  { label: "استرداد طلب",     Icon: ArrowDown, color: "text-green-600", bg: "bg-green-50" },
};

function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("ar", { dateStyle: "medium", timeStyle: "short" });
  } catch { return ""; }
}

export default function TransactionsList({ transactions = [] }) {
  return (
    <div className="bg-white rounded-3xl talabya-shadow-soft overflow-hidden" data-testid="transactions-list">
      <div className="px-5 py-3 border-b border-[var(--border)] flex items-center justify-between">
        <h2 className="font-black text-lg" style={{fontFamily:"Cairo"}}>سجل العمليات</h2>
        <span className="text-xs text-[var(--text-secondary)]">{transactions?.length || 0} عملية</span>
      </div>
      {(!transactions || transactions.length === 0) ? (
        <div className="p-8 text-center text-sm text-[var(--text-secondary)]" data-testid="wallet-empty">
          لا توجد عمليات بعد. عند شحن محفظتك ستظهر التفاصيل هنا.
        </div>
      ) : (
        <ul className="divide-y divide-[var(--border)]" data-testid="wallet-tx-list">
          {transactions.map((tx) => {
            const meta = TYPE_META[tx.type] || { label: tx.type, Icon: WalletIcon, color: "text-gray-600", bg: "bg-gray-50" };
            const Icon = meta.Icon;
            return (
              <li key={tx.id} className="p-4 flex items-center gap-3" data-testid={`wallet-tx-${tx.id}`}>
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${meta.bg}`}>
                  <Icon size={16} className={meta.color}/>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-sm truncate">{meta.label}</div>
                  {tx.note && <div className="text-xs text-[var(--text-secondary)] truncate">{tx.note}</div>}
                  {tx.order_code && (
                    <Link to={`/track/${tx.order_id}`} className="text-[11px] text-primary-brand font-bold">
                      طلب #{tx.order_code}
                    </Link>
                  )}
                </div>
                <div className="text-left">
                  <div className={`font-black ${tx.amount >= 0 ? "text-green-600" : "text-red-600"}`}>
                    {tx.amount >= 0 ? "+" : ""}{tx.amount.toFixed(2)} د.ل
                  </div>
                  <div className="text-[10px] text-[var(--text-secondary)]">{fmtDate(tx.created_at)}</div>
                  <div className="text-[10px] text-[var(--text-secondary)]">رصيد: {tx.balance_after?.toFixed(2)}</div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
